// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeeCurrencySelect_wrapper__F5GZw","title":"FeeCurrencySelect_title__2vj2j"};